// RunModal.js
import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, onSnapshot, deleteDoc, doc } from 'firebase/firestore';
import { useAuth } from "../contexts/AuthContext";

const RunModal = ({ onClose, onSelectRun }) => {
  const { user } = useAuth();
  const [runs, setRuns] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortType, setSortType] = useState("date");
  const [sortOrder, setSortOrder] = useState("desc");

  useEffect(() => {
    if (!user) return;
    // TODO: After Firebase migration, change 'events' to 'runs'
    const runsRef = collection(db, 'events');
    const unsubscribe = onSnapshot(runsRef, (snapshot) => {
      const runsList = snapshot.docs
        .map(docSnap => ({ id: docSnap.id, ...docSnap.data() }))
        // If you want to restrict to runs the user owns, adjust here.
        .filter(run => run.userId === user.uid);
      setRuns(runsList);
    });
    return () => unsubscribe();
  }, [user]);

  const handleDeleteRun = async (runId) => {
    const runToDelete = runs.find((r) => r.id === runId);
    const runName = runToDelete?.name || "this run";

    const confirmed = window.confirm(
      `Are you sure you want to delete "${runName}"?\n\nThis action cannot be undone and will permanently remove the run and all its data.`
    );

    if (!confirmed) {
      return;
    }

    try {
      // TODO: After Firebase migration, change 'events' to 'runs'
      await deleteDoc(doc(db, 'events', runId));
    } catch (error) {
      console.error("Error deleting run:", error);
    }
  };

  const sortRuns = (runsList) => {
    return runsList.sort((a, b) => {
      if (sortType === "name") {
        return sortOrder === "asc" ? a.name.localeCompare(b.name) : b.name.localeCompare(a.name);
      } else if (sortType === "date") {
        const aTime = a.createdAt || 0;
        const bTime = b.createdAt || 0;
        return sortOrder === "asc" ? aTime - bTime : bTime - aTime;
      }
      return 0;
    });
  };

  const filteredRuns = runs.filter(run =>
    run.name.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const sortedRuns = sortRuns(filteredRuns);

  return (
    <div style={{ position: 'relative', padding: '20px' }}>
      {/* Cross button in the top right */}
      <button
        onClick={onClose}
        style={{
          position: 'absolute',
          top: '10px',
          right: '10px',
          background: 'transparent',
          border: 'none',
          fontSize: '1.5em',
          color: '#000',
          cursor: 'pointer'
        }}
      >
        &times;
      </button>
      <h2 style={{ marginBottom: '20px' }}>Select a Run</h2>
      <div style={{ marginBottom: "10px", display: 'flex', gap: '10px' }}>
        <input 
          type="text" 
          placeholder="🔍 Search runs..." 
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{ padding: "5px", flex: 1 }}
        />
        <button 
          onClick={() => {
            if(sortType === "name") {
              setSortOrder(sortOrder === "asc" ? "desc" : "asc");
            } else {
              setSortType("name");
              setSortOrder("asc");
            }
          }}
          style={{
            backgroundColor: "#13A1A8",
            color: "#fff",
            border: "none",
            padding: "10px 15px",
            borderRadius: "5px",
            cursor: "pointer"
          }}
        >
          Sort by Name {sortType === "name" ? (sortOrder === "asc" ? "▲" : "▼") : ""}
        </button>
        <button 
          onClick={() => {
            if(sortType === "date") {
              setSortOrder(sortOrder === "asc" ? "desc" : "asc");
            } else {
              setSortType("date");
              setSortOrder("asc");
            }
          }}
          style={{
            backgroundColor: "#FE6C62",
            color: "#fff",
            border: "none",
            padding: "10px 15px",
            borderRadius: "5px",
            cursor: "pointer"
          }}
        >
          Sort by Date {sortType === "date" ? (sortOrder === "asc" ? "▲" : "▼") : ""}
        </button>
      </div>
      <ul style={{ listStyle: "none", padding: 0 }}>
        {sortedRuns.map(run => (
          <li key={run.id} style={{ marginBottom: "10px", display: "flex", alignItems: "center", justifyContent: "space-between", borderBottom: "1px solid #ccc", paddingBottom: "5px" }}>
            <div>
              <strong>{run.name}</strong>
              <br />
              <small>{run.createdAt ? new Date(run.createdAt).toLocaleString() : ""}</small>
            </div>
            <div>
              <button
                onClick={() => onSelectRun(run)}
                style={{
                  backgroundColor: "#13A1A8",
                  color: "#fff",
                  border: "none",
                  padding: "10px 15px",
                  borderRadius: "5px",
                  cursor: "pointer",
                  marginRight: "10px"
                }}
              >
                Select
              </button>
              <button
                onClick={() => handleDeleteRun(run.id)}
                style={{
                  backgroundColor: "#FF4D4D",
                  color: "#fff",
                  border: "none",
                  padding: "10px 15px",
                  borderRadius: "5px",
                  cursor: "pointer"
                }}
              >
                Delete
              </button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default RunModal;